<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="Dedication-ded" id="ded"><span aria-label="v" id="pg_v" role="doc-pagebreak"> <i>This year has been a tough one everywhere. New York, especially, has been hit hard by COVID-19. But the city is no stranger to crisis, and once again, New Yorkers are rising to the occasion. This book is dedicated to the city of New York: to the health workers, scientists, public servants, and volunteers on the frontlines of the crisis; to the essential workers of all stripes, from teachers to bus drivers to grocery store clerks putting themselves at risk to keep the city running; to the ordinary New Yorkers going out of their way for their friends and neighbors and strangers in need. You are, as always, an inspiration.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?26528cb3